import dynamic from 'next/dynamic'
import { FC } from 'react'
import LazyLoad from 'react-lazyload'
import LayoutLandingPage from '~/components/Layout/LayoutLandingPage'
import DriveMeasurableSection from '~/components/TalentIntelligence/DriveMeasurableSection'
import JobAndCandidateSection from '~/components/TalentIntelligence/JobAndCandidateSection'
import SkillFoundationSection from '~/components/TalentIntelligence/SkillFoundationSection'
// import TalentIntelligenceSection from '~/components/TalentIntelligence/TalentIntelligenceSection'
import TalentIntelligenceSectionv2 from '~/components/TalentIntelligence/TalentIntelligenceSectionv2'
import UnlockGrowthAndCrossFunctionalSection from '~/components/TalentIntelligence/UnlockGrowthAndCrossFunctionalSection'
import WorkforceSection from '~/components/TalentIntelligence/WorkforceSection'

const LazyLoadWrapper = LazyLoad as unknown as FC<any>

const JourneySection = dynamic(
  () => import('~/components/LandingPage/JourneySection')
)

const TalentIntelligenceContainer: FC = () => {
  return (
    <LayoutLandingPage>
      <TalentIntelligenceSectionv2 />

      <LazyLoadWrapper height={300} once>
        <SkillFoundationSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <WorkforceSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <JobAndCandidateSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <UnlockGrowthAndCrossFunctionalSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <DriveMeasurableSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <JourneySection className="desktop:mt-[140px] desktop:mb-[0px] bg-gray-50 mt-[64px] my-[0px] py-[64px]" />
      </LazyLoadWrapper>
    </LayoutLandingPage>
  )
}

export default TalentIntelligenceContainer
